import { useState, useEffect } from 'react'
import ManagerMobileLayout from '../../components/ManagerMobileLayout'
import api from '../../lib/api'

interface Employee {
  id: string
  firstName: string
  lastName: string
  contractType: string
  weeklyHours: number
  conventionLevel: string
  hourlyRate: number
  status: string
  phone?: string
  email?: string
}

const CONTRACT_COLORS: Record<string, string> = {
  CDI: 'bg-blue-100 text-blue-700', CDD: 'bg-orange-100 text-orange-700', Extra: 'bg-purple-100 text-purple-700'
}

export default function ManagerTeam() {
  const [employees, setEmployees] = useState<Employee[]>([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => {
    api.get('/employees?status=active').then(r => setEmployees(r.data)).finally(() => setLoading(false))
  }, [])

  const filtered = employees.filter(e =>
    `${e.firstName} ${e.lastName}`.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <ManagerMobileLayout>
      <div className="p-4 space-y-4">
        <h1 className="text-lg font-bold text-gray-800">Mon équipe</h1>

        <input value={search} onChange={e => setSearch(e.target.value)}
          placeholder="Rechercher un employé..."
          className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 bg-white" />

        {loading ? (
          <div className="text-center py-12 text-gray-400">Chargement...</div>
        ) : (
          <div className="space-y-2">
            {filtered.map(emp => (
              <div key={emp.id} className="bg-white rounded-2xl shadow-sm p-4 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-indigo-400 to-blue-500 flex items-center justify-center text-white font-bold flex-shrink-0">
                  {emp.firstName[0]}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-gray-800">{emp.firstName} {emp.lastName !== '-' ? emp.lastName : ''}</div>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${CONTRACT_COLORS[emp.contractType] || 'bg-gray-100 text-gray-600'}`}>
                      {emp.contractType}
                    </span>
                    <span className="text-xs text-gray-500">{emp.weeklyHours}h/sem</span>
                    <span className="text-xs text-gray-400">{emp.conventionLevel}</span>
                  </div>
                  {emp.phone && <div className="text-xs text-gray-400 mt-0.5">📞 {emp.phone}</div>}
                </div>
                <div className="text-right flex-shrink-0">
                  <div className="text-sm font-medium text-gray-700">{emp.hourlyRate.toFixed(3)} €/h</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </ManagerMobileLayout>
  )
}
